import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { IncidentTypeFormPage } from "@/pages/dashboard/incident-report-types/form";

export const Route = createFileRoute("/_main/dashboard/incident-report-types/$id/edit")({
  component: () => (
    <RequirePermission action="lookups.manage">
      <IncidentTypeFormPage />
    </RequirePermission>
  ),
});
